'use client';
import { forwardRef, useMemo } from 'react';
import { Box } from '@wanteddev/wds-engine';
import WithInteraction from '../with-interaction/index.mjs';
import PushBadge from '../push-badge/index.mjs';
import { iconButtonStyle, backgroundBlendStyle } from './style.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var IconButton = forwardRef(
  ({
    as,
    disabled = false,
    disableInteraction = false,
    size,
    variant = "normal",
    interactionColor = "palette.label.normal",
    pushBadge = false,
    alternative,
    color: originColor,
    children,
    xs,
    sm,
    md,
    lg,
    xl,
    ...props
  }, ref) => {
    const color = useMemo(() => {
      if (originColor) {
        return originColor;
      }
      switch (variant) {
        case "solid":
          return "palette.static.white";
        case "background":
          return void 0;
        default:
          return "palette.label.normal";
      }
    }, [originColor, variant]);
    const getInteractionSize = () => {
      switch (variant) {
        case "outlined":
        case "solid":
          return "100%";
        case "background":
          return "calc(100% + 8px)";
        case "normal":
          return "calc(100% + 16px)";
      }
    };
    const getInteractionVariant = () => {
      switch (variant) {
        case "normal":
        case "outlined":
          return "light";
        case "background":
          return alternative ? "normal" : "light";
        case "solid":
          return "strong";
      }
    };
    const interactionSize = getInteractionSize();
    return /* @__PURE__ */ jsx(
      WithInteraction,
      {
        width: interactionSize,
        height: interactionSize,
        color: interactionColor,
        disabled: disableInteraction || disabled,
        variant: getInteractionVariant(),
        scale: variant === "normal",
        children: /* @__PURE__ */ jsxs(
          Box,
          {
            as: as || "button",
            ref,
            "wds-component": "icon-button",
            "data-variant": variant,
            disabled,
            type: "button",
            "aria-disabled": disabled,
            ...props,
            sx: [
              iconButtonStyle({
                variant,
                size,
                alternative,
                color,
                xs,
                sm,
                md,
                lg,
                xl
              }),
              props.sx
            ],
            children: [
              variant === "background" && !alternative && /* @__PURE__ */ jsx(
                Box,
                {
                  as: "span",
                  role: "presentation",
                  "data-role": "icon-button-background-alternative",
                  sx: backgroundBlendStyle
                }
              ),
              children,
              pushBadge && /* @__PURE__ */ jsx(
                PushBadge,
                {
                  variant: "dot",
                  sx: {
                    position: "absolute",
                    right: "-10px",
                    top: "-10px"
                  }
                }
              )
            ]
          }
        )
      }
    );
  }
);
IconButton.displayName = "IconButton";
var icon_button_default = IconButton;

export { icon_button_default as default };
